import { Box } from '@mui/material'
import { EmtTypography, EmtModal, EmtButton } from 'emt-components-v2'
import React, { useState } from 'react'
import AddressLocationForm from './AddressLocationForm'
import { useIsResponsive } from '@/hooks'
import { Address } from '@/dataV3/Common/Address'
import { useSignUpCallRequestStore } from '@/store/signUpCallRequestStore'

interface EditLocationModalProps {
  open: boolean
  setOpen: (open: boolean) => void
}

const EditLocationModal: React.FC<EditLocationModalProps> = ({ open, setOpen }) => {
  const address = useSignUpCallRequestStore((s) => s.address)
  const setAddress = useSignUpCallRequestStore((s) => s.setAddress)
  const [localAddress, setLocalAddress] = useState<Address>(
    address || {
      '@id': '',
      '@type': 'Address',
      formatted: '',
      zipCode: '',
      city: '',
      country: '',
      latitude: 0,
      longitude: 0,
    },
  )
  const [valid, setValid] = useState<boolean>(!!address?.formatted)
  const [isMobile] = useIsResponsive()

  React.useEffect(() => {
    setLocalAddress(
      address || {
        '@id': '',
        '@type': 'Address',
        formatted: '',
        zipCode: '',
        city: '',
        country: '',
        latitude: 0,
        longitude: 0,
      },
    )
    setValid(!!address?.formatted)
  }, [open, address])

  const handleSubmit = (addr: Address) => {
    setAddress(addr)
    setOpen(false)
  }

  return (
    <EmtModal
      open={open}
      onClose={(event: React.MouseEvent) => {
        event.stopPropagation()
        setOpen(false)
      }}
      sx={{
        '& .inner-box': { width: '800px', maxWidth: '90vw' },
        '& .children-box': { padding: isMobile ? '26px' : '66px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
        }}
      >
        <EmtTypography variant="h4" fontWeight={800}>
          Modifier l&apos;adresse de recherche :
        </EmtTypography>
        <AddressLocationForm
          initialAddress={localAddress}
          onChange={(addr, isValid) => {
            setLocalAddress(addr)
            setValid(isValid)
          }}
        />
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: '10px',
            justifyContent: 'center',
          }}
        >
          <EmtButton fullWidth variant="outlined" size="medium" color="purple" onClick={() => setOpen(false)}>
            Annuler
          </EmtButton>
          <EmtButton
            fullWidth
            size="medium"
            color="purple"
            onClick={() => handleSubmit(localAddress)}
            disabled={!valid}
          >
            Valider
          </EmtButton>
        </Box>
      </Box>
    </EmtModal>
  )
}

export default EditLocationModal
